import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import ClipLoader from "react-spinners/ClipLoader";
import { Dialog, Button, CustomCheckBox, Image } from "hesus-ui-kit";
import {
  addSpace,
  addSpaceWithoutFloat,
  renderPriceWithCurrency,
  renderPriceWithCurrencyWithoutUnit,
} from "@utils/utils";
import closeIcon from "@icons/ic-close-white.svg";

import {
  HeaderWrapper,
  PopUpHeaderWrapper,
  ButtonWrapper,
  FormBody,
  Title,
  GrayDarkerSpan,
  GrayDarkerServiceSpanWithoutBullet,
  GraySpan,
  ServiceSection,
} from "./EnquirySellingPrice.styled";

import {
  FlexRow,
  GridRow,
  MarginDiv,
  SectionContainer,
  SolutionValidateTitle,
} from "../../SellingPricesList.styled";

const EnquirySellingPriceValidated = (props) => {
  const {
    t,
    sellingPriceData,
    onClose,
    sellingPriceItemIds,
    setSellingPriceItemIds,
    onSolutionValidateSubmit,
    isSolutionValidating,
  } = props;

  const updateCheckStatus = (e, itemId, combination, servicesList) => {
    // e.target.checked;
    const itemIds = [...sellingPriceItemIds];
    if (!combination) {
      if (e.target.checked) {
        itemIds.push(itemId);
      } else {
        const itemIdIndex = itemIds.indexOf(itemId);
        if (itemIdIndex >= 0) itemIds.splice(itemIdIndex, 1);
      }
    }
    if (combination) {
      servicesList.map((service) => {
        if (service?.hesusCatalogService?.combination) {
          if (e.target.checked) {
            itemIds.push(service.id);
          } else {
            const itemIdIndex = itemIds.indexOf(service.id);
            if (itemIdIndex >= 0) itemIds.splice(itemIdIndex, 1);
          }
        }
      });
    }

    setSellingPriceItemIds(itemIds);
  };

  return (
    <Dialog>
      <div>
        <PopUpHeaderWrapper>
          <Title>{t("SELLING_PRICE_SOLUTION_ASSOCIATION_POPUP_TITLE")}</Title>
          <Button
            onClick={onClose}
            styles={{
              backgroundColor: "transparent",
              border: "none",
              height: "auto",
              padding: 0,
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            <Image
              src={closeIcon}
              alt="close meeting report popup"
              styles={{ width: "auto " }}
            />
          </Button>
        </PopUpHeaderWrapper>
        <FormBody>
          <FlexRow>
            <SectionContainer>
              <div>
                <GridRow>
                  <SolutionValidateTitle>
                    {t("SELLING_PRICE_SOLUTION_ASSOCIATION_POPUP_DESCRIPTION")}
                  </SolutionValidateTitle>
                </GridRow>
                {sellingPriceData?.map((data, index) => {
                  return (
                    <ServiceSection
                      key={"sellingPriceListvalidate_" + index}
                      color="#fff"
                    >
                      <GridRow
                        column="100%"
                        gap="0rem"
                        marginTop="10px"
                        marginBottom="10px"
                      >
                        <HeaderWrapper
                          backgroundColor="#008395"
                          marginTop="0px"
                          padding="10px;"
                        >
                          <FlexRow>
                            <Title>
                              {"#" + data?.id}
                              {data?.hesusCatalog?.label
                                ? " - " + data?.hesusCatalog?.label
                                : ""}
                              {data?.label ? " - " + data?.label : ""}
                            </Title>
                          </FlexRow>
                        </HeaderWrapper>
                      </GridRow>
                      {data.services?.length !== "" &&
                        data.services?.map((service, indexService) => {
                          return (
                            <GridRow
                              column="45% 1fr 1fr 1fr"
                              marginBottom={indexService === 0 ? "1px" : "3px"}
                              padding="0px 10px"
                              key={
                                "sellingPriceServiceList_" +
                                index +
                                indexService
                              }
                            >
                              <MarginDiv
                                marginLeft={
                                  service?.hesusService?.needSolution
                                    ? "0px"
                                    : "26px"
                                }
                              >
                                {service?.hesusService?.needSolution && (
                                  <CustomCheckBox
                                    id={`selling-price-validated-${parseInt(
                                      service.id,
                                      10
                                    )}`}
                                    dataId={parseInt(service.id, 10)}
                                    onChange={(e) => {
                                      updateCheckStatus(
                                        e,
                                        service.id,
                                        service?.hesusCatalogService
                                          ?.combination,
                                        data.services
                                      );
                                    }}
                                    checked={
                                      sellingPriceItemIds.indexOf(
                                        service.id
                                      ) !== -1
                                    }
                                  />
                                )}
                                <GrayDarkerServiceSpanWithoutBullet
                                  weight="700"
                                  color="#474747"
                                >
                                  {service?.hesusService?.name}
                                </GrayDarkerServiceSpanWithoutBullet>
                                <GraySpan>
                                  {service?.hesusService?.needProduct
                                    ? " - " + service?.product?.name
                                    : ""}
                                  {service?.hesusService?.needTransport
                                    ? " - " + service?.transportType?.name
                                    : ""}
                                </GraySpan>
                              </MarginDiv>
                              <GraySpan textAlign="center">
                                {addSpaceWithoutFloat(service.quantity) +
                                  " " +
                                  t(service.unit)}
                              </GraySpan>
                              <GraySpan textAlign="center">
                                {renderPriceWithCurrency(
                                  addSpace(service?.unitPrice),
                                  t(service?.unit),
                                  data?.currency?.symbol,
                                  data?.currency?.position
                                )}
                              </GraySpan>
                              <GrayDarkerSpan
                                color="#474747"
                                textAlign="right"
                                weight="700"
                              >
                                {renderPriceWithCurrencyWithoutUnit(
                                  addSpace(service?.totalPrice),
                                  data?.currency?.symbol,
                                  data?.currency?.position
                                )}
                              </GrayDarkerSpan>
                            </GridRow>
                          );
                        })}
                    </ServiceSection>
                  );
                })}
              </div>
            </SectionContainer>
          </FlexRow>
        </FormBody>
        <ButtonWrapper>
          <Button
            styles={{
              color: "#333",
              background: "#fff",
              border: "1px solid #ccc",
              marginRight: "0.32rem",
              "&:hover": {
                backgroundColor: "#ccc",
              },
            }}
            onClick={onClose}
          >
            {t("CANCEL")}
          </Button>

          <Button
            styles={{
              color: "white",
              background: "#1BACE4",
              border: "1px solid #1BACE4",
              marginRight: "0.32rem",
              "&:hover": {
                backgroundColor: "#1589b6",
              },
            }}
            onClick={onSolutionValidateSubmit}
          >
            <>
              {isSolutionValidating && <ClipLoader size={15} color="#fff" />}
              {!isSolutionValidating && t("VALIDATE")}
            </>
          </Button>
        </ButtonWrapper>
      </div>
    </Dialog>
  );
};

EnquirySellingPriceValidated.propTypes = {
  t: PropTypes.func.isRequired,
  page: PropTypes.string,
};

EnquirySellingPriceValidated.defaultProps = {
  page: "enquiryView",
};
export default withTranslation()(EnquirySellingPriceValidated);
